import { render, staticRenderFns } from "./ELabelWithInstructions.vue?vue&type=template&id=bfdd076e&class=col-md-1&"
import script from "./ELabelWithInstructions.vue?vue&type=script&lang=js&"
export * from "./ELabelWithInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfdd076e')) {
      api.createRecord('bfdd076e', component.options)
    } else {
      api.reload('bfdd076e', component.options)
    }
    module.hot.accept("./ELabelWithInstructions.vue?vue&type=template&id=bfdd076e&class=col-md-1&", function () {
      api.rerender('bfdd076e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ELabelWithInstructions.vue"
export default component.exports